export const PROVIDERS_FETCH_STARTED = 'PROVIDERS_FETCH_STARTED';
export const PROVIDERS_FETCH_COMPLETED = 'PROVIDERS_FETCH_COMPLETED';
export const PROVIDERS_FETCH_FAILED = 'PROVIDERS_FETCH_FAILED';
